var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.is_land
      ? _c(
          "div",
          { staticClass: "adjust_editor" },
          [
            _c(
              "b-row",
              { staticClass: "mem_create_row" },
              [
                _c(
                  "b-col",
                  {
                    attrs: {
                      "offset-md": "7",
                      md: "5",
                      xs: "6",
                      "offset-xs": "6",
                      lg: "5",
                      "offset-lg": "7",
                      xl: "4",
                      "offset-xl": "8",
                    },
                  },
                  [
                    _vm.is_parts
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-lg btn-primary waves-effect waves-themed w-100 mt-5 mb-5",
                            attrs: { type: "button" },
                            on: { click: _vm.show_parts_modal },
                          },
                          [
                            _c("span", { staticClass: "fal fa-eject mr-1" }),
                            _vm._v(
                              "\n                    Редагувати запчастини\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-primary waves-effect waves-themed w-100 mb-2 mt-2",
                        attrs: { type: "button" },
                        on: { click: _vm.show_adjust_editor },
                      },
                      [
                        _c("span", { staticClass: "fal fa-eject mr-1" }),
                        _vm._v(
                          "\n                        Редагувати погодження\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-primary waves-effect waves-themed w-100",
                        attrs: { type: "button" },
                        on: { click: _vm.show_invoice_editor },
                      },
                      [
                        _c("span", { staticClass: "fal fa-eject mr-1" }),
                        _vm._v(
                          "\n                        Редагувати повідомлення\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm.is_land && _vm.can_replace_last_adjust
      ? _c(
          "div",
          { staticClass: "adjust_editor" },
          [
            _c(
              "b-row",
              { staticClass: "mem_create_row" },
              [
                _c(
                  "b-col",
                  {
                    attrs: {
                      "offset-md": "7",
                      md: "5",
                      xs: "6",
                      "offset-xs": "6",
                      lg: "5",
                      "offset-lg": "7",
                      xl: "4",
                      "offset-xl": "8",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-primary waves-effect waves-themed w-100 mb-2 mt-2",
                        attrs: { type: "button" },
                        on: { click: _vm.show_adjust_replacer },
                      },
                      [
                        _c("span", { staticClass: "fal fa-eject mr-1" }),
                        _vm._v(
                          "\n                    Заміна останнього погоджувача\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }